import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Column } from 'primereact/column'

import { PanelContainer } from '../../../../components/Panel'
import { AllowanceCharge } from '../../../../data/models'
import { ConfigurableTable } from '../../../../utils/wrapper'
import { useConfigContext } from '../../../ui-config/context'
import { useInvoiceById } from '../../data'
import {
  AcceptAllowanceCharges,
  AddAllowanceCharge,
  EditAllowanceCharge,
  InfoAllowanceCharge,
  RejectAllowanceCharges,
} from './dialogs'

type Props = {
  invoiceId: string
}

export const AllowanceCharges: React.FC<Props> = ({ invoiceId }) => {
  const { t } = useTranslation()

  const { data: invoice, isLoading } = useInvoiceById(invoiceId)
  const { uiConfig: config } = useConfigContext()

  const [selectedItems, setSelectedItems] = useState<AllowanceCharge[] | null>()

  const headerTitle = t('invoice.allowanceCharges.title')
  const headerActions = (
    <>
      <RejectAllowanceCharges
        invoiceId={invoiceId}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
      />

      <AcceptAllowanceCharges
        invoiceId={invoiceId}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
      />

      <AddAllowanceCharge invoiceId={invoiceId} />
    </>
  )

  //  action template
  const actionBodyTemplate = (rowData: any) => {
    return (
      <>
        <div className="flex justify-content-end flex-nowrap">
          <InfoAllowanceCharge invoiceId={invoiceId} id={rowData.Id} />

          <EditAllowanceCharge invoiceId={invoiceId} id={rowData.Id} />
        </div>
      </>
    )
  }

  const buttons = <Column key="buttons" body={actionBodyTemplate}></Column>

  const isSelectable = (data: AllowanceCharge) => {
    return data.Status !== 'REJECTED' // if not REJECTED it is selectable
  }

  const isRowSelectable = (event: any) => {
    return event.data ? isSelectable(event.data) : true
  }

  // deactivate the row if it is REJECTED
  const rowClassName = (data: AllowanceCharge) => {
    return isSelectable(data) ? '' : 'p-disabled'
  }

  return (
    <PanelContainer
      header={t('invoice.allowanceCharges.title')}
      id="invoice-allowanceCharges"
      visible={config.invoice.allowanceCharges.enabled}
    >
      <ConfigurableTable
        config={config.invoice.allowanceCharges.table}
        data={invoice?.Payload.AllowanceCharges}
        buttons={buttons}
        headerTitle={headerTitle}
        headerActions={headerActions}
        checkboxen={true}
        selected={selectedItems}
        setSelected={setSelectedItems}
        isDataSelectable={isRowSelectable}
        rowClassName={rowClassName}
        isLoading={isLoading}
        stateKey=""
      />
    </PanelContainer>
  )
}
